import { AppDispatch } from 'src/store';
import axios from 'src/workspace/axios';
import {
  setData,
  setError,
  setLoading,
  setSuccess,
  setVerificationStatus,
} from './slice';
import { FormAuthPayload } from './types';

type VerifyOtpPayload = FormAuthPayload & {
  otp: string;
};

export const sendOtp =
  (payload: FormAuthPayload) => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      const response = await axios.post('/users/auth/otp/send-otp', {
        ...payload,
        source: 'web',
        timestamp: payload.timestamp ?? Date.now(),
      });

      const { data } = response;

      if (data.error_code !== 0) {
        dispatch(setError(data.error || data.message));
        return;
      }

      dispatch(setData(data));
    } catch (error: any) {
      dispatch(setError(error?.response?.data?.message || 'OTP send failed'));
    } finally {
      dispatch(setLoading(false));
    }
  };

export const verifyOtp =
  (payload: VerifyOtpPayload) => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    dispatch(setSuccess(false));
    dispatch(setVerificationStatus('idle'));

    try {
      const response = await axios.post('/users/auth/otp/verify-otp', {
        ...payload,
        source: payload.source ?? 'web',
        timestamp: payload.timestamp ?? Date.now(),
      });

      const { data } = response;

      if (data.error_code !== 0) {
        dispatch(setError(data.error || data.message));
        dispatch(setVerificationStatus('error'));
        return;
      }

      dispatch(setData(data));
      dispatch(setSuccess(true));
      dispatch(setVerificationStatus('success'));
    } catch (error: any) {
      dispatch(
        setError(error?.response?.data?.message || 'OTP verification failed'),
      );
      dispatch(setVerificationStatus('error'));
    } finally {
      dispatch(setLoading(false));
    }
  };
